import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-600 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/a361490e7833dbbd1748fc8855ca4234.png" 
                alt="İpek Yangın Söndürme" 
                className="h-24 w-auto"
              />
            </div>
            <p className="text-white/80 mb-6 leading-relaxed">
              Yangın güvenliği konusunda profesyonel çözümler sunuyoruz. Güvenliğiniz bizim önceliğimiz.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center hover:bg-white hover:text-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center hover:bg-white hover:text-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center hover:bg-white hover:text-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center hover:bg-white hover:text-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-display font-semibold text-lg mb-6">Hızlı Linkler</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Anasayfa
                </Link>
              </li>
              <li>
                <Link to="/hizmetlerimiz" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Hizmetlerimiz
                </Link>
              </li>
              <li>
                <Link to="/urunler" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Ürünler
                </Link>
              </li>
              <li>
                <Link to="/kurumsal" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Kurumsal
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/sss" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  S.S.S.
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-display font-semibold text-lg mb-6">Hizmetlerimiz</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/hizmetlerimiz/yangin-tupu-satis" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Yangın Tüpü Satış
                </Link>
              </li>
              <li>
                <Link to="/hizmetlerimiz/yangin-tupu-dolum" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Yangın Tüpü Dolum
                </Link>
              </li>
              <li>
                <Link to="/hizmetlerimiz/yangin-tupu-bakim" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Yangın Tüpü Bakım
                </Link>
              </li>
              <li>
                <Link to="/hizmetlerimiz/yangin-sondurme-ekipmanlari" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Yangın Ekipmanları
                </Link>
              </li>
              <li>
                <Link to="/hizmetlerimiz/baca-temizligi" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Baca Temizliği
                </Link>
              </li>
              <li>
                <Link to="/hizmetlerimiz/davlumbaz-temizligi" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Davlumbaz Temizliği
                </Link>
              </li>
              <li>
                <Link to="/hizmetlerimiz/otomatik-davlumbaz-sondurme-sistemi" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Otomatik Söndürme Sistemi
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-display font-semibold text-lg mb-6">İletişim</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-white text-xl mt-1"></i>
                <span className="text-white/80">
                  Kopça Sokak No:33/3<br />
                  Siteler, Altındağ / Ankara
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-phone-line text-white text-xl"></i>
                <a href="tel:+905319619192" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  0531 961 91 92
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-mail-line text-white text-xl"></i>
                <a href="mailto:info@ipekyanginsondurme.com" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  info@ipekyanginsondurme.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-time-line text-white text-xl mt-1"></i>
                <div className="text-white/80">
                  <p>Pazartesi - Cumartesi</p>
                  <p>09:00 - 18:00</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-white/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/70 text-sm text-center md:text-left">
              © {currentYear} İpek Yangın Söndürme. Tüm hakları saklıdır.
            </p>
            <a
              href="https://www.webkitdesign.com"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-lg px-4 py-2 hover:shadow-lg transition-all cursor-pointer"
            >
              <img 
                src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/39b92a04ca56b3f2710ac3b83474600b.png" 
                alt="Webkit Design" 
                className="h-8 w-auto"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
